import { useId } from 'react';

interface StepperInputProps {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  ariaLabel?: string;
  readOnly?: boolean;
}

export function StepperInput({
  value,
  onChange,
  min = 0,
  ariaLabel,
  readOnly = false,
}: StepperInputProps) {
  const id = useId();
  return (
    <div className="inline-flex items-center border border-gray-200 rounded-md overflow-hidden">
      <button
        type="button"
        aria-label="decrement"
        className="px-2 py-1 text-gray-600 hover:bg-gray-50 disabled:opacity-40"
        disabled={readOnly || value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        −
      </button>
      <input
        id={id}
        type="number"
        aria-label={ariaLabel ?? 'quantity'}
        readOnly={readOnly}
        className="w-12 text-center outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none read-only:bg-gray-50 read-only:text-gray-500"
        value={value}
        min={min}
        onChange={(e) => {
          if (readOnly) return;
          const raw = e.target.value;
          if (raw === '') {
            onChange(min);
            return;
          }
          const n = Number(raw);
          if (!Number.isFinite(n)) return;
          onChange(Math.max(min, Math.floor(n)));
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
        }}
      />
      <button
        type="button"
        aria-label="increment"
        className="px-2 py-1 text-gray-600 hover:bg-gray-50 disabled:opacity-40"
        disabled={readOnly}
        onClick={() => onChange(value + 1)}
      >
        +
      </button>
    </div>
  );
}
